import styled from 'styled-components';

export const AddHandlerDialogStyle = styled.div`
.associate-handler-add-handler-body{
  margin-bottom: 300px;
}

.after-box-submit{
  float: right;
  margin-right: 25px;
}

.long-input{
  .irGLIb{
    width: 410px!important;
  }
}

.associate-handler-create-handler-body{
  .unique-error{
    color: red;
    padding-left: 10px;
    font-style: italic;
  }
}
`;
